import {
  FrontDoorDataset,
  FrontDoorStepType,
  VisitExperienceDataset,
} from './front-door';

type Id = number;

export enum JourneyType {
  FrontDoor = 'front_door',
  EncounterLookup = 'encounter_lookup',
}

export enum BaseJourneyStepType {
  CustomForm = 'custom_form',
  UserValidation = 'user_validation',
}

export enum JourneyActionType {
  Primary = 'primary',
  Secondary = 'secondary',
  Custom = 'custom',
  Conditional = 'conditional',
}

export enum ConditionType {
  WeekdayTimeRange = 'weekday_time_range',
}

export type DateTimeRangeActionCondition = {
  condition_type: ConditionType;
  from_time: string;
  to_time: string;
  week_days: string;
};

export type JourneyStepType = BaseJourneyStepType | FrontDoorStepType;
export type JourneyActionCondition = DateTimeRangeActionCondition;

export type JourneyAction = {
  action_type: JourneyActionType;
  condition?: JourneyActionCondition;
  name?: string;
  step_id?: Id;
};

export type CustomFormDataset = {
  custom_form_id?: Id;
  custom_form_version_id?: Id;
};

export type ValidationDataset = {
  validation_tag?: string;
};

export type JourneyStepDataset = CustomFormDataset &
  VisitExperienceDataset &
  ValidationDataset;

export type JourneyStep = {
  id: Id;
  step_type: JourneyStepType;
  name?: string;
  description?: string;
  actions?: JourneyAction[];
  dataset?: JourneyStepDataset;
  position?: { x: number; y: number };
};

export type BaseJourneyDataset = {
  steps: Record<Id, JourneyStep>;
};

export type JourneyDataset = FrontDoorDataset;

export type JourneyStatus = 'active' | 'inactive' | 'draft';

export type Journey = {
  id: Id;
  owner_id: Id;
  status: JourneyStatus;
  name: string;
  title?: string;
  journey_type: JourneyType;
  dataset: JourneyDataset;
  locale?: string;
};
